<template>
  <v-expansion-panels
          class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>Tìm kiếm chỉ tiêu</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
                class="ma-0"
                outlined
        >
          <v-list-item class="pa-0" three-line>
            <v-list-item-content class="pa-0">
<!--              <v-list-item-title class="headline mb-2">-->
<!--                Tìm kiếm chỉ tiêu-->
<!--              </v-list-item-title>-->
              <v-row>
                <v-col
                        cols="12"
                        sm="6"
                >
                  <v-text-field
                          v-model="filterForm.keyword"
                          label="Tìm kiếm"
                          placeholder="Tìm kiếm theo tên..."
                          clearable
                          @keyup.enter="searchKpiTitle"
                  />
                </v-col>
              </v-row>
              <div class="text-center mb-4">
                <v-btn
                        class="primary mx-0"
                        @click="searchKpiTitle"
                >
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  const KpiRepository = RepositoryFactory.get('kpi')
  export default {
    name: 'KpiFilterForm',
    props: {
      filterForm: {
        default: () => ({}),
      },
    },
    data () {
      return {
        kpis_data: [],
      }
    },
    created () {
    },
    methods: {
      async getKpiList () {
        const response = await KpiRepository.list()
        if (_.get(response, 'success', false)) {
          this.kpis_data = _.get(response, 'data')
        }
      },
      searchKpiTitle () {
        Bus.$emit('kpi-list-filter', this.filterForm)
      },
    },
  }
</script>
